module.exports = __webpack_public_path__ + "static/img/sassxt.988fc25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sassxt.png
// module id = tRFi
// module chunks = 0